import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthErrorPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login", {
      replace: true,
      state: {
        authAlert: {
          type: "error",
          message: "Пользователь не найден. Оставьте заявку на демо",
        },
      },
    });
  }, [navigate]);

  return null;
};
